import { map } from 'lodash';
import React from 'react';
import "./Episodes.css";
import {GoPrimitiveDot} from 'react-icons/go'

 const data=[
     {

        title: "Prayer That Works",
        date: "Aug. 9",
        long_date: "August 9",
        subtitle: "The best way to connect with God",
        description: "In a world full of stress and uncertainty, find out how to connect with God in a meaningful way.",
        img: require("../../Assets/episode1.jpg"),
     },
     {

        title: "Supercharged Prayer",
        date: "Aug. 10",
        long_date: "August 10",
        subtitle: "ABCs of connecting with God",
        description: "Hoping that things will change in life doesn't go very far, but connecting with God engages all the power of heaven.",
        img: require("../../Assets/episode2.jpg"),
     },
     {

        title: "An Atheist's Perspective On Prayer",
        date: "Aug. 11",
        long_date: "August 11",
        subtitle: "The power of connection",
        description: "Some people say prayer is a waste of time. Discover how logical and effective prayer actually is.",
        img: require("../../Assets/episode3.jpg"),
     },
     {

        title: "Beyond Aladdin's Lamp",
        date: "Aug. 12",
        long_date: "August 12",
        subtitle: "Pros and cons of being connected",
        description: "Prayer is not about giving God a wish list, but rather aligning with His plans.",
        img: require("../../Assets/episode4.jpg"),
     },
     {

        title: "When Prayer Doesn't Work",
        date: "Aug. 13",
        long_date: "August 13",
        subtitle: "Making a successfull connection",
        description: "When it seems that God doesn’t answer prayer, what then?",
        img: require("../../Assets/episode5.jpg"),
     },

 ]



export const Episodes = () => {


    const render = () => {
        return map(data, (item, index) => {


            return(
                <div className="episode-container">
                    <div className="episode-left-container">
                        <div className="episode-left-inner-left">
                            <span className="episode-left-inner-name">Episode {index + 1}</span>
                            <img src={require("../../Assets/pink_line.svg")} alt={"pink line"} />
                            {/* <span className="episode-long-date">{item.long_date}</span> */}
                        </div>

                            <img 
                                className="episode-left-container-img"
                                src={item.img} 
                                alt={`${item.title} Image`} 
                            />

                    </div>
                    <div className="episode-right-container">
                        <div style={{display: 'flex', alignItems: "flex-start"}}>
                            <span  className="desktop-hide pink episode-right-h5" style={{whiteSpace: "nowrap"}}></span>
                            <span className="pink episode-right-h5">{item.title}</span>
                        </div>
                        <img 
                            className={'episode-right-pink'}
                            src={require("../../Assets/pink_line.svg")} 
                            alt={"pink line"} 
                        />
                        {/* <h6 className="pink">{item.subtitle}</h6> */}
                        <span className="episode-desc">{item.description}</span>
                    </div>
                </div>
            )
        })
    }


    return (
        <div className="episode-outer-container">
            {render()}
        </div>
    )
}